/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom'
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { DragSource } from 'react-dnd'

import { TableRow, TableCell, Tooltip, IconButton, CircularProgress, Menu, MenuItem, Typography } from '@material-ui/core'
import { MoreVert, SyncProblem } from '@material-ui/icons'

import FieldIcon from './FieldIcon'
import SingletonIcon from '../Singletons/SingletonIcon'

const fieldSourceSpec = {
    beginDrag(props, monitor, component) {
        return {
            field_data : props.field_data,
            location : props.location
        }
    },
    endDrag(props, monitor, component) {
        return props.handleDropped({
            field_data: props.field_data,
            location : props.location
        }, props.field_type, monitor.getDropResult())
    },
    canDrag(props, monitor) {
        console.log("IFC :: Dragging : ", props.field_data)
        if (props.location === 'NewGroup') {
            return false
        }

        if (props.unsynced_fields.includes(props.field_data.field)) {
            return false
        }

        if (props.syncing_field === props.field_data.field) {
            return false
        } else {
            return true
        }
    }
}

function collect (connect, monitor) {
    return {
        connectDragSource : connect.dragSource(),
        connectDragPreview : connect.dragPreview(),
        isDragging : monitor.isDragging()
    }
}

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class Field extends Component {
    state = {
        anchorEl : null
    }

    isUnsynced = () => {
        if (this.props.unsynced_fields.includes(this.props.field_data.field)) {
            return true
        } else {
            return false
        }
    }

    isSyncing = () => {
        if (this.props.field_data.field === this.props.syncing_field) {
            return true
        } else {
            return false
        }
    }

    isFocussed = () => {
        if (this.props.field_in_focus === null) {
            return false
        } else {
            if (this.props.field_in_focus.field === this.props.field_data.field) {
                return true
            } else {
                return false
            }
        }
    }

    createNewGroup = () => {
        let field_data = {
            field_data: this.props.field_data,
            location : this.props.location
        }
        this.props.create_new_group_from_field(field_data)
        this.handleMenu()
    }

    makeSingleton = () => {
        let field_data = {
            field_data: this.props.field_data,
            location : this.props.location
        }
        this.props.make_singleton(field_data)
        this.handleMenu()
    }

    highlightedName = () => {
        let start_index = this.props.field_data.matching_start_index
        let end_index = this.props.field_data.matching_end_index
        let text = this.props.field_data.field.split("").map((char, i) => {
            if (i >= start_index && i <= end_index) {
                return (
                    <mark style = {{backgroundColor : 'yellow', padding : 0}} key = {i}>{char}</mark>
                )
            } else {
                return (
                    <span>{char}</span>
                )
            }
        })

        return text
    }

    renderName = () => {
        if (this.props.field_type === 'singleton') {
            return (
            <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
            >
                <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}</Typography>
                {this.props.field_data.global_mapped_field !== null &&
                    <Tooltip title = "Mapped to Global Field">
                        <Typography style = {{fontSize : 10, fontWeight : 600}} variant = 'caption' color = "primary" >{this.props.field_data.global_mapped_field }</Typography>
                    </Tooltip>
                }
            </TableCell>)
        } else {
            return (
                <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
                >
                    {this.props.show_group_name ? 
                    <Fragment>
                        <Typography style = {{fontSize : 10}} variant = 'caption' color = 'textSecondary' display = 'inline'>{this.props.field_data.group_name + " / "}</Typography>
                        <Typography style = {{fontSize : 12}} variant = 'body2' display = 'inline'>
                            {this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}
                        </Typography>
                    </Fragment>: 
                    <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}</Typography>}
                </TableCell>
            )
        }
    }

    renderFieldCell = (cell) => {
        switch (cell) {
            case "$icon":
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                            fontSize : 12
                        }}
                        align = 'center'
                    >
                        {this.isUnsynced() ? 
                        <Tooltip title = "Unsynced">
                            <SyncProblem style = {{color : '#ff9800'}} fontSize = 'small'/>
                        </Tooltip>:
                        this.isSyncing() ? 
                            <CircularProgress variant = 'indeterminate' color = 'primary' size = {20}/>
                        : this.props.field_type === 'singleton' ? <SingletonIcon/> :<FieldIcon field_display_name = {this.props.field_display_name}/>}
                    </TableCell>
                )
            
            case "Name" :
                return this.renderName()

            case "Score":
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                            fontSize : 13,
                            fontWeight : 900,
                            color : '#03AD93'
                        }}
                        align = 'center'
                    >
                        {this.props.field_data.score ? this.props.field_data.score.toFixed(2) : ""}
                    </TableCell>
                )

            case "$options" :
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                        }}
                        align = 'center'
                    >
                        <IconButton 
                        disabled = {this.isSyncing()}
                        style = {{padding : 0, margin : 0}} 
                        size = 'small' 
                        onClick = {(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                            this.handleMenu(event)
                        }}
                        >
                            <MoreVert style = {{color : '#707070'}} fontSize = 'small'/>
                        </IconButton>
                    </TableCell>
                )
            default : 
                return null
        }
    }

    handleMenuClose = () => {
        this.setState({...this.state, anchorEl : null})
    }

    handleMenu = (event) => {
        if (this.state.anchorEl) {
            this.setState({...this.state, anchorEl : null})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget})
        }
    }

    renderMenu = () => {
        if (this.props.location === 'Singletons') {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.createNewGroup}
                    >New Group</MenuItem>
                </Menu>
            )
        }

        if (this.props.location !== 'NewGroup') {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.createNewGroup}
                    >New Group</MenuItem>
                    {this.props.field_type !== 'singleton' && <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.makeSingleton}
                    >Make Singleton</MenuItem>}
                </Menu>
            )
        } else {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem onClick = {this.removFieldFromNewGroup}>Remove Field</MenuItem>
                </Menu>
            )
        }
    }

    removFieldFromNewGroup = () => {
        this.setState({...this.state, anchorEl: null}, () => this.props.remove_field(this.props.field_data.field))
    }

    renderFieldRows = () => {
        let {field_data} = this.props
        const { isDragging, connectDragSource } = this.props
        const opacity = isDragging ? 0 : 1
        return (
            <TableRow
                style = {{
                    backgroundColor : this.isSyncing() ? 'FAFAFA' : this.isFocussed() ? '#EBF7FF' : '#FFFFFF',
                    padding : '10px',
                    boxShadow : this.isUnsynced() ? "" : this.isSyncing() ? '' : '1px 2px 12px -9px rgba(0,0,0,0.49)',
                    width : '90%',
                    cursor : this.isSyncing() ? '' : 'pointer',
                    opacity : opacity
                }}
                onClick = {(event) => this.isFocussed() ? this.props.unfocus_field() : this.props.focus_field(this.props.field_data, this.props.field_type, event)}
                ref = {instance => connectDragSource(findDOMNode(instance))}
                onDrag = {(event) => {
                    event.stopPropagation();
                    event.nativeEvent.stopImmediatePropagation();
                }}
            >
                {this.props.columns.map(cell => {
                    return this.renderFieldCell(cell)
                })}
            </TableRow>   
        )
    }

    render() {
        const { classes } = this.props
        const { isDragging, connectDragSource } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderFieldRows()}
                {this.renderMenu()}
            </ThemeProvider>
        );
    }
}
 
export default (withStyles(styles)(DragSource('field', fieldSourceSpec, collect)(Field)))